import { combineReducers, Reducer } from "redux";
import { routerReducer } from "react-router-redux";

import * as fromAppsModels from "@apps-store/models/index";
import * as fromAppsReducers from "@apps-store/reducers/reducers";


// combine all reducers
export const fromCombineReducer: Reducer<fromAppsModels.ReducersInterface<any>> = combineReducers<any>({
    delayed:fromAppsReducers.DelayedReducer,    // temps différé
    login:fromAppsReducers.LoginReducer,     // connection
    logout:fromAppsReducers.DeconnexionReducer,     // déconnexion
    realTimes:fromAppsReducers.RealTimesReducer, 
    router: routerReducer,
    stats:fromAppsReducers.StatsReducer,
    
})




// WEBPACK FOOTER //
// ./src/apps/store/reducers/index.ts